import Component from '../core/Component'

export default class CopyToClipboard extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            source: null,
            copy: null
        }
    }

    prepare() {
        this.ref.source.addEventListener('click', ::this.handleSourceClick)
        this.ref.copy.addEventListener('click', ::this.handleCopyClick)
    }

    handleSourceClick(event) {
        this.select()
    }

    handleCopyClick(event) {
        event.preventDefault()
        this.select()
        this.copy()
    }

    select() {
        this.ref.source.select()
    }

    copy() {
        try {
            const success = document.execCommand('copy')
        } catch (err) {
            alert('Text nelze zkopírovat')
        }
    }
}